module.exports = __webpack_public_path__ + "media/images/admin2/CheckBox--checked-gray-065aeab818b54c785056c872a1b1fea9.svg";